import * as OpenCC from 'opencc-js'
import enLocales from './en-us.js'
import zhLocales from './zh.js'
import zhHkLocales from './zh-hk.js'

// 不需要继续向下递归的元素
const noInclude = new Set(['script', 'noscript', 'style', 'meta', 'img', 'svg', 'path', 'g'])

export let lang = 'zh-cn'

let observer

let converter

// 设置整个页面的语言
export function translatePage(tLang = 'zh-cn') {
  if (!tLang) return

  if (!observer) {
    observer = new MutationObserver(translateDom)
    observer.observe(document.body, {
      subtree: true,
      childList: true,
      // 监听文本变化
      characterData: true,
      // 不监听属性变化
      attributes: false
    })
  }

  if (updateLang(tLang)) translateDom([document.body])
}

function updateLang(tLang) {
  if (!tLang) return

  if (lang === tLang) return false

  const oldLang = lang
  lang = tLang

  if (lang.startsWith('zh-')) {
    converter = OpenCC.Converter({
      from: oldLang.replace('zh-', ''),
      to: tLang.replace('zh-', '')
    })
  }

  return true
}

// 翻译dom下所有的文本
export function translateDom(domList) {
  if (!domList) return

  domList.forEach((mutationRecord) => {
    const dom = mutationRecord.target ?? mutationRecord

    // 跳过无需操作的dom
    if (!dom || noInclude.has(dom?.localName) || noInclude.has(`class:${dom?.className}`)) return

    if (dom.nodeType === 3 && dom.textContent?.trim() && /[\u4e00-\u9fa5]/g.test(dom.textContent)) {
      // 执行翻译操作
      const transStr = translate(dom.textContent)

      /**
       * TODO 此处为临时方案
       * observer监听了文本变化，此处如果不写该判断，直接dom.textContent = transStr
       * 会导致再次触发文本更新，产生循环导致页面卡死
       *
       * 但该方案会使某一个节点的流程变为
       * 文本变化 -> 翻译 -> 翻译导致文本变化 -> 翻译并与dom.textContent比较发现一致，不做更改
       * 上面的translate会执行两次
       */
      if (dom.textContent !== transStr) {
        dom.textContent = transStr
      }
    } else if (dom.nodeType === 1) translateDom(dom.childNodes)
  })
}

// 简体繁体转换
export function translate(text) {
  const i18nText = i18nTranslateInit.t(text)
  // 优先使用 i18n 的翻译文案
  if (i18nText) {
    return i18nText
  }

  return converter ? converter(text) : text
}

class I18nTranslate {
  constructor() {
    this.lang = this.getLang()
  }
  getLang() {
    if (typeof localStorage === 'undefined') return 'zh-cn'

    return localStorage.getItem('lang') || 'zh-cn'
  }

  setLang(lang) {
    this.lang = lang
  }
  init({ resources }) {
    return {
      t: (val, obj) => this.t(resources[this.getLang()], val, obj),
      useOpenCC: (val) => this.useOpenCC(resources[this.getLang()], val),
      setLang: this.setLang,
      lang: this.lang
    }
  }
  t(res, val, obj) {
    // this.lang 没更新， 用this.getLang()替换
    // console.log(this.lang, this.getLang())
    // 如果存在 obj，比如 obj 为 {x: 123}，则 res?.translation[val] 取出来的值要判断是否有 {{x}}，然后替换成 obj 的 x 值
    if (
      obj &&
      res?.translation[val] &&
      /\{\{\s*(\w+)\s*\}\}/g.test(res.translation[val]) &&
      Object.keys(obj).some((key) => res.translation[val].includes(`{{${key}}}`))
    ) {
      return res.translation[val].replace(/{{\s*(\w+)\s*}}/g, (_, key) =>
        Object.prototype.hasOwnProperty.call(obj, key) ? obj[key] : ''
      )
    }

    return res?.translation[val] || converter?.(val) || val
  }
  // 针对图表无法用暴力方法
  useOpenCC(res, val) {
    // this.lang 没更新， 用this.getLang()替换
    return res.useOpenCC(val)
  }
}
const resources = {
  zh: {
    translation: zhLocales,
    useOpenCC: (val, obj) => i18nTranslateInit.t(val, obj)
  },
  'zh-cn': {
    translation: zhLocales,
    useOpenCC: (val, obj) => i18nTranslateInit.t(val, obj)
  },
  'zh-hk': {
    translation: zhHkLocales,
    useOpenCC: (val) => OpenCC.Converter({ from: 'cn', to: 'hk' })(val)
  },
  'en-us': {
    translation: enLocales,
    useOpenCC: (val, obj) => i18nTranslateInit.t(val, obj)
  }
}

export const i18nTranslateInit = new I18nTranslate().init({
  resources
})

function initLang() {
  // 由于 useSearchParams 只能在router组件下使用，所以此处只能自行获取参数
  const _location = window.location.href
  const params = _location.split('?')?.[1]
  const qs = new URLSearchParams(params)

  updateLang(qs.get('lang') ?? '')
}

initLang()
